export const getFilteredOperationsVariables = (startDate, endDate, marketType) => ({
  filters: {
    marketType: marketType,
    destinationId: null,
    endDate: {
      maxDate: endDate,
      minDate: startDate,      
      // "maxDate": "2024-03-31T00:00:00.000Z",
      // "minDate": "2024-03-01T00:00:00.000Z",
    },
    incoterms: [],
    statuses: ['CONFIRMED'],
    isWM: false,
    isWarehouse: false,
  },
});